<template>
    <div>
        <h3 v-if="headerText">{{$t("AbsenceRequestsAdding")}}:</h3>
        <div class="vx-row justify-around">
            <vs-button class="mt-6" type="border" color="warning" @click="addVacationPrompt = true" >{{$t("AddVacation")}}</vs-button>
            <vs-button class="mt-6" type="border" color="warning" @click="addSickLeavePrompt = true" >{{$t("AddSickLeave")}}</vs-button>
            <vs-button class="mt-6" type="border" color="warning" @click="addAbsencePrompt = true" >{{$t("AddAbsence")}}</vs-button>
            <vs-button class="mt-6" type="border" color="warning" @click="addParentalLeavePrompt = true" >{{$t("AddParentalLeave")}}</vs-button>
        </div>



        <vs-popup :title="$t('AddAbsence')" :active.sync="addAbsencePrompt">
            <p class="mt-6">{{$t("StartTime")}}</p>
            <flat-pickr :config="configDateTimePicker" v-model="newAbsence['start']"></flat-pickr>
            <p class="mt-6">{{$t("EndTime")}}</p>
            <flat-pickr :config="configDateTimePicker" v-model="newAbsence['end']"></flat-pickr>

            <p class="mt-6">{{$t("Description")}}</p>
            <vs-textarea v-model="newAbsence['notes']" class="w-full" />
            <vs-divider/>
            <vs-button color="success" class="mt-6; mr-1" @click="addAbsence">{{$t("Add")}}</vs-button>
        </vs-popup>

        <vs-popup :title="$t('AddSickLeave')" :active.sync="addSickLeavePrompt">
            <p class="mt-6">{{$t("StartTime")}}</p>
            <flat-pickr :config="configDateTimePicker" v-model="newSickLeave['start']"></flat-pickr>
            <p class="mt-6">{{$t("EndTime")}}</p>
            <flat-pickr :config="configDateTimePicker" v-model="newSickLeave['end']"></flat-pickr>

            <p class="mt-6">{{$t("Description")}}</p>
            <vs-textarea v-model="newSickLeave['notes']" class="w-full" />
            <vs-divider/>
            <vs-button color="success" class="mt-6; mr-1" @click="addSickLeave">{{$t("Add")}}</vs-button>
        </vs-popup>

        <vs-popup :title="$t('AddParentalLeave')" :active.sync="addParentalLeavePrompt">
            <p class="mt-6">{{$t("StartTime")}}</p>
            <flat-pickr :config="configDateTimePicker" v-model="newParentalLeave['start']"></flat-pickr>
            <p class="mt-6">{{$t("EndTime")}}</p>
            <flat-pickr :config="configDateTimePicker" v-model="newParentalLeave['end']"></flat-pickr>

            <p class="mt-6">{{$t("Description")}}</p>
            <vs-textarea v-model="newParentalLeave['notes']" class="w-full" />
            <vs-divider/>
            <vs-button color="success" class="mt-6; mr-1" @click="addParentalLeave">{{$t("Add")}}</vs-button>
        </vs-popup>

        <vs-popup :title="$t('AddVacation')" :active.sync="addVacationPrompt">
            <p class="mt-6">{{$t("StartTime")}}</p>
            <flat-pickr :config="configDateTimePicker" v-model="newVacation['start']"></flat-pickr>
            <p class="mt-6">{{$t("EndTime")}}</p>
            <flat-pickr :config="configDateTimePicker" v-model="newVacation['end']"></flat-pickr>

            <p class="mt-6">{{$t("Description")}}</p>
            <vs-textarea v-model="newVacation['notes']" class="w-full" />
            <vs-divider/>
            <vs-button color="success" class="mt-6; mr-1" @click="addVacation">{{$t("Add")}}</vs-button>
        </vs-popup>
    </div>
</template>
<script>

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default{
        props: {
            baseURL: {
                type: String,
                required: true,
            },
            headerText: {
                type: Boolean,
                required: false,
                default: true,
            }
        },
        components: {
            flatPickr,
        },
        data() {
            return {
                addAbsencePrompt: false,
                newAbsence: {},

                newSickLeave: {},
                addSickLeavePrompt: false,

                newParentalLeave: {},
                addParentalLeavePrompt: false,

                newVacation: {},
                addVacationPrompt: false,

                configDateTimePicker: {
                    enableTime: false,
                    dateFormat: 'Y-m-d',
                    locale: {
                        firstDayOfWeek: 1
                    }
                },
            }
        },
        methods: {
            addAbsence() {
                const thisIns = this;
                this.$http.post(this.baseURL + '/absence/', {
                    start: thisIns.moment(thisIns.newAbsence.start).format(),
                    end: thisIns.moment(thisIns.newAbsence.end).format(),
                    notes: thisIns.newAbsence.notes
                }).then(function () {
                    thisIns.addAbsencePrompt = false;
                    thisIns.newAbsence = {};
                    thisIns.$emit('updateAbsence', '');
                }).catch(function (error) {
                    thisIns.addAbsencePrompt = false;
                    thisIns.$emit('updateAbsence', '');
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            addSickLeave() {
                const thisIns = this;
                this.$http.post(this.baseURL + '/sick_leave/', {
                    start: thisIns.moment(thisIns.newSickLeave.start).format(),
                    end: thisIns.moment(thisIns.newSickLeave.end).format(),
                    notes: thisIns.newSickLeave.notes
                }).then(function () {
                    thisIns.addSickLeavePrompt = false;
                    thisIns.newSickLeave = {};
                    thisIns.$emit('updateSickLeaves', '');
                }).catch(function (error) {
                    thisIns.addSickLeavePrompt = false;
                    thisIns.$emit('updateSickLeaves', '');
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            addParentalLeave() {
                const thisIns = this;
                this.$http.post(this.baseURL + '/parental_leave/', {
                    start: thisIns.moment(thisIns.newParentalLeave.start).format(),
                    end: thisIns.moment(thisIns.newParentalLeave.end).format(),
                    notes: thisIns.newParentalLeave.notes
                }).then(function () {
                    thisIns.addParentalLeavePrompt = false;
                    thisIns.newParentalLeave = {};
                    thisIns.$emit('updateParentalLeaves', '');
                }).catch(function (error) {
                    thisIns.addParentalLeavePrompt = false;
                    thisIns.$emit('updateParentalLeaves', '');
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            addVacation() {
                const thisIns = this;
                this.$http.post(this.baseURL + '/vacation/', {
                    start: thisIns.moment(thisIns.newVacation.start).format(),
                    end: thisIns.moment(thisIns.newVacation.end).format(),
                    notes: thisIns.newVacation.notes
                }).then(function () {
                    thisIns.addVacationPrompt = false;
                    thisIns.newVacation = {};
                    thisIns.$emit('updateVacations', '');
                }).catch(function (error) {
                    thisIns.addVacationPrompt = false;
                    thisIns.$emit('updateVacations', '');
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
        }
    }
</script>
